import classNames from "classnames";

import { Term } from "../../utils/interfaces";
import styles from "./PileSorter.module.css"

type PileProps = {
  label: string;
  name: string;
  items: Array<Term>;
}
type PileComponentProps = {
  currentTerm: Term;
  pile: PileProps;
  onSort: (value: Term, category: string) => void;
}
type PileSorterProps = {
  label: string;
  onSort: (value: Term, category: string) => void;
  resetPile: () => void;
  sorted: Array<PileProps>;
  undoMoveCard: () => void;
  unsorted: Array<Term>;
};

function Card({ item, label }: { item: Term, label: string }) {
  if (!item) {
    return (
      <div className={styles.currentCard}>
        <h4>All {label} sorted</h4>
      </div>
    )
  }

  return (
    <div className={styles.currentCard}>
      <h4>{item.term}</h4>
      <p>{item.definition}</p>
    </div>
  )
}

function Pile({ currentTerm, pile, onSort }: PileComponentProps) {
  const handleClick = () => {
    if (currentTerm) onSort(currentTerm, pile.name)
  }
  const classes = classNames(styles.pile, {
    [styles.empty]: !currentTerm,
  }) 
  
  return (
    <button className={classes} onClick={handleClick}>
      <h4 className={styles.title}>{pile.label}</h4>
      <span className={styles.count}>({pile.items.length})</span>
    </button>
  )
}

export default function PileSorter({
  label, 
  onSort, 
  resetPile, 
  sorted, 
  undoMoveCard,
  unsorted, 
}: PileSorterProps) {
  const currentTerm = unsorted[0]
  return (
    <div className={styles.container}>
      <Card item={currentTerm} label={label} />
      <div className={styles.pileContainer}>
        {sorted.map(sortedPile => <Pile key={sortedPile.label} pile={sortedPile} currentTerm={currentTerm} onSort={onSort} />)}
      </div>
    </div>
  )
}
